import React from 'react';
import { styled } from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import ReportDialogTitle from './ReportDialogTitle';
import ReportDialogAction from './ReportDialogAction';
import { ReportOptions } from './ReportOptions';
import styles from './ReportDialogs.scss';

const ReportDialog = styled(Dialog)(() => ({
    '& .MuiPaper-root': {
        overflow: 'visible',
    },
    '& .MuiDialogContent-root': {
        overflowY: 'visible',
    },
}));

const DialogDownloadReport = props => {
    const { reportLabel, reportOptions, reportData, canSubmitReport, loadReport, dialogOpen, toggleDialog } = props;

    return (
        <div data-cy="DialogDownloadReport">
            <ReportDialog
                open={dialogOpen}
                onClose={toggleDialog}
                fullWidth
                aria-labelledby="form-dialog-title"
                className={styles.dialogContainer}
            >
                <ReportDialogTitle onClose={toggleDialog} children={reportLabel} />
                <DialogContent>
                    <ReportOptions reportOptions={reportOptions} reportData={reportData} />
                </DialogContent>
                <ReportDialogAction
                    reportLabel={reportLabel}
                    canSubmitReport={canSubmitReport}
                    toggleDialog={toggleDialog}
                    loadReport={loadReport}
                />
            </ReportDialog>
        </div>
    );
};

export default DialogDownloadReport;
